export default "__VITE_ASSET__NHi_0Tp___"